import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";

// components
import Header from "../components/Header";
import ListAll from "../components/ListAll";
import Search from "../components/Search";

// sources
import DeleteBannerBtn from "../assets/icons/delete.svg";

import Loading from "../assets/img/loading.jpg";

import { useTranslation, Trans } from "react-i18next"; // 1. react-i18next import

const lngs = {
  en: { nativeName: "English" },
  ko: { nativeName: "Korean" },
};

// Haversine 공식을 사용하여 두 지점 간의 거리를 계산하는 함수
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // 지구의 반경 (km)
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// 좌표 목록을 특정 지점으로부터의 거리에 따라 정렬하는 함수
function sortCoordinatesByDistance(coordinates, centerLat, centerLon) {
  return coordinates.sort((a, b) => {
    const distanceA = calculateDistance(
      centerLat,
      centerLon,
      a.latlng.x,
      a.latlng.y
    );
    const distanceB = calculateDistance(
      centerLat,
      centerLon,
      b.latlng.x,
      b.latlng.y
    );
    return distanceA - distanceB;
  });
}

const Home = ({ places, exhibitions, experiences, shuttles, etcs, banner }) => {
  const startPoint = JSON.parse(sessionStorage.getItem("startPoint"));
  const { t, i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  if (searchParams.get("lng") === "en-US" && i18n.language !== "en-US") {
    i18n.changeLanguage("en-US");
  }

  const [isPathVisible, setIsPathVisible] = useState(false);
  const [visibility, setvisibility] = useState("visible");
  const fadeDuration = 3;

  // const [endPoint, setEndPoint] = useState({});
  const [isBannerVisible, setIsBannerVisible] = useState(
    i18n.language === "en-US" ? false : true
  );
  const [searchWord, setSearchWord] = useState("");
  const emptySpace = searchWord === "" ? "0" : "12px";
  const onSearch = (e) => {
    const keyword = e.target.value;
    setSearchWord(keyword);
    // if (keyword !== startPoint?.name[i18n.language]) {
    // }
  };

  const onHideBanner = () => setIsBannerVisible(false);

  const showPath = () => {
    setIsPathVisible(true);
  };
  const hidePath = () => {
    setIsPathVisible(false);
  };

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    banner !== undefined && setIsLoading(false);
    banner !== undefined &&
      sessionStorage.setItem("isLoading", JSON.stringify(false));
  }, [banner]);

  // if (!isLoading) {
  //   setTimeout(() => {
  //     setvisibility('hidden')
  //   }, fadeDuration)
  // }

  // return
  // (isLoading) ? (<div style={{ width: "100%", height: "100%", backgroundClor: "white", zIndex: 10, backgroundColor: "white", position: "absolute" }}><img src={Loading} alt="Loading..." style={{ position: "absolute", top: "30vh", left: "20vw", width: "60vw" }} /></div>) :
  return (
    <div>
      {/* {!isLoading && (
        <Fade>
          <div style={{
            width: "100%", height: "100%", backgroundClor: "white",
            zIndex: 10,
            backgroundColor: "white",
            position: "absolute",

            // opacity: "0",
            // visibility: "hidden",
            // transition: "opacity 1000ms , visibility 1000ms",
          }}>
            <img src={Loading} alt="Loading..." style={{ position: "absolute", top: "30vh", left: "20vw", width: "60vw" }} />
          </div>
        </Fade>
      )} */}

      <div
        style={{
          position: isPathVisible ? "fixed" : "inherit",
        }}
      >
        <Header
          view={"list"}
          onSearch={onSearch}
          searchWord={searchWord}
          onDeleteWord={() => setSearchWord("")}
        />

        <div
          style={{
            position: "absolute",
            top: "138px",
            width: "100%",
            height: "8px",
            backgroundColor: "#EEEFF3",
          }}
        />

        {searchWord === "" ? (
          <ListAll
            isBannerVisible={isBannerVisible}
            all={
              startPoint !== undefined
                ? sortCoordinatesByDistance(
                    [...exhibitions, ...experiences, ...shuttles, ...etcs],
                    startPoint?.latlng.x,
                    startPoint?.latlng.y
                  )
                : [...exhibitions, ...experiences, ...shuttles, ...etcs]
            }
            exhibitions={
              startPoint !== undefined
                ? sortCoordinatesByDistance(
                    exhibitions,
                    startPoint?.latlng.x,
                    startPoint?.latlng.y
                  )
                : exhibitions
            }
            experiences={
              startPoint !== undefined
                ? sortCoordinatesByDistance(
                    experiences,
                    startPoint?.latlng.x,
                    startPoint?.latlng.y
                  )
                : experiences
            }
            shuttles={
              startPoint !== undefined
                ? sortCoordinatesByDistance(
                    shuttles,
                    startPoint?.latlng.x,
                    startPoint?.latlng.y
                  )
                : shuttles
            }
            etcs={
              startPoint !== undefined
                ? sortCoordinatesByDistance(
                    etcs,
                    startPoint?.latlng.x,
                    startPoint?.latlng.y
                  )
                : etcs
            }
            showPath={showPath}
          />
        ) : (
          <Search
            // startPoint={startPoint}
            isBannerVisible={isBannerVisible}
            places={places}
            searchWord={searchWord}
          />
        )}

        {/* Banner */}
        {isBannerVisible && (
          <div
            style={{
              position: "fixed",
              display: "flex",
              width: "100vw",
              overflowX: "hidden",

              // height: bannerHeight,
              zIndex: 2,
              bottom: "-5px",
              // inset: "auto 0 0 auto",
              // backgroundColor: "#ffeb34",
              color: "#423630",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <a href={banner.url} target="_blank" rel="noopener noreferrer">
              <img
                src={banner.img}
                alt="카카오 T 자동결제 신청하기"
                style={{
                  width: "100%",
                  maxHeight: "100px",
                  backgroundColor: "#243073",
                }}
              />
            </a>
            <button
              onClick={onHideBanner}
              style={{
                position: "absolute",
                top: "0px",
                right: "0px",
                backgroundColor: "transparent",
                border: "none",
                zIndex: 1,
                padding: "10px",
              }}
            >
              <img src={DeleteBannerBtn} alt="" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

Home.propTypes = {
  places: PropTypes.array,
  exhibitions: PropTypes.array,
  experiences: PropTypes.array,
  shuttles: PropTypes.array,
  etcs: PropTypes.array,
  banner: PropTypes.string,
};

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;
const Fade = styled.div`
  display: inline-block;
  visibility: hidden;
  animation: ${fadeOut} 1s linear;
  transition: visibility 1s linear;
`;

export default Home;
